import CommandsManager from './CommandsManager.js';
import HotkeysManager from './HotkeysManager.js';
import ImageSet from './ImageSet';
import MetadataProvider from './MetadataProvider';

export {
  MetadataProvider,
  CommandsManager,
  HotkeysManager,
  ImageSet,
};

const classes = {
  MetadataProvider,
  CommandsManager,
  HotkeysManager,
  ImageSet,
};

export default classes;
